import { render, staticRenderFns } from "./MomentumStats.vue?vue&type=template&id=851e675e&scoped=true"
import script from "./MomentumStats.vue?vue&type=script&lang=js"
export * from "./MomentumStats.vue?vue&type=script&lang=js"
import style0 from "./MomentumStats.vue?vue&type=style&index=0&id=851e675e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851e675e",
  null
  
)

export default component.exports